// extracted by mini-css-extract-plugin
export default {"breakpoints":"\"~web/react/components/common/styles/breakpoints.module.css\"","large":"only screen and (min-width: 992px)","imageCardContainer":"_2KW7g","discovery":"dPnBi"};